export const environment = {
  production: false,
  recaptcha:{
    siteKey: '6LcWDhUqAAAAAEINnFhacmhTFEZn4g-RZlDwpJbH'
  },
  serviceUrl:'https://www.gov.il/api/molsa/TendersApi',
  govPaynetUrl: 'http://ecom.gov.il/counter/general/default.aspx?counter=49&catalog=1&category=molsatenders_1_molsatenders',
  registrationFormUrl: 'https://auth.govforms.gov.il/mw/forms/RegistrationUpdatesAboutTenders@molsa.gov.il/?TenderID={{TenderId}}&TenderNumber={{TenderNumber}}&Title={{TenderTitle}}'
};
//ng run TendersAngular:build:prodgov -- --base-href /apps/molsa/tenders --deploy-url tenders/
//npm run build -- --configuration=prodgov
